import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow } from "../components/Reveal";
import { fullDate } from "../lib/format";
import { imgSrc } from "../lib/api";

export const PastEvents = ({ concerts }) => {
  const past = concerts.filter((c) => c.is_past).reverse();
  if (!past.length) return null;
  return (
    <section data-testid="past-events-section" className="mx-auto max-w-7xl px-5 pb-20 lg:px-12">
      <Eyebrow color="text-zinc-400">Past Events</Eyebrow>
      <ul className="mt-5 divide-y divide-white/10 border-y border-white/10">
        {past.map((c) => (
          <li key={c.slug}>
            <Link to={`/concerts/${c.slug}`} data-testid={`past-event-${c.slug}`} className="group flex items-center gap-5 py-5">
              <img src={imgSrc(c.image)} alt="" className="h-14 w-14 shrink-0 rounded-xl object-cover grayscale transition duration-500 group-hover:grayscale-0" loading="lazy" />
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-2xl font-bold uppercase text-zinc-200 group-hover:text-white">{c.artist}</p>
                <p className="text-sm text-zinc-400">{fullDate(c.date)} · {c.genre}</p>
              </div>
              <ArrowRight size={18} className="text-zinc-400 transition-transform group-hover:translate-x-1 group-hover:text-sunset" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
